import React, { useEffect, useRef, useState } from "react";
import { CiMenuKebab } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoDuplicateOutline } from "react-icons/io5";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { FaEdit, FaRegEdit, FaTrash } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { Badge, Col, Collapse, Container, Form, ListGroup, Row } from "react-bootstrap";
import { globalFormManagementServices } from "../../../../../APIServices/globalFormManagementServices";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import RangeScale from "../FormList/RangeScale";
import FormCustomization from "./FormCustomization";
import UseToggle from "../../../../../Hooks/UseToggle";
import UpdateFormFieldLibrary from "./UpdateFormFieldLibrary";
import AddFormFieldLibraryForm from "./AddFormFieldLibraryForm";
import ScorePercentageGraph from "../FormList/ScorePercentageGraph";

const FormFieldLibraryEditor = ({ setCategoryId, categoryId, handleFormFieldDelete, handleUpdateFormField, handleDuplicateFormField, setFormFields, formFields, handleAddFormField }) => {
  const [fieldId, setFieldId] = useState("");
  const [loading, setLoading] = useState(false);
  const [openOption, setOpenOption] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [activeTab, setActiveTab] = useState("general");
  const [fieldLoading, setFieldLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selectScaleIndex, setSelectScaleIndex] = useState(null);
  const [conditionaLogicTab, setConditionaLogicTab] = useState("field")
  const [formFieldLibraryList, setFormFieldLibraryList] = useState([]);
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const AppsRef = useRef(null);
  
  const getGlobalFormFieldGroupLibrary = async (e) => {
    setLoading(true);
    let data = await globalFormManagementServices.getGlobalFormFieldGroupLibrary();
    setFormFieldLibraryList(data?.data || []);
    setLoading(false);
  };

  const findGlobalFormFieldGroupLibrary = async (e) => {
    setFieldLoading(true);
    let data = await globalFormManagementServices.findGlobalFormFieldGroupLibrary(categoryId);
    setFormFields(data?.data || []);
    setFieldLoading(false);
  };

  const addUpdateGlobalFormFieldLibrary = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Form Fields!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.categoryId = categoryId;
        userData.formFields = formFields
        let data = await globalFormManagementServices.addUpdateGlobalFormFieldLibrary(userData);
        if (data?.statusCode === 200) {
          findGlobalFormFieldGroupLibrary();
        }
      }
    });
  };

  const deleteGlobalFormFieldLibrary = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete Form Field Library!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.ids = [id];
        let data = await globalFormManagementServices.deleteGlobalFormFieldLibrary(userData);
        if (data?.statusCode === 200) {
          getGlobalFormFieldGroupLibrary();
          findGlobalFormFieldGroupLibrary()
          setOpenOption(false)
        }
      }
    });
  };

  const updateGlobalFormLibraryField = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Form Field Library!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.categoryId = categoryId;
        userData.categoryName = categoryName
        let data = await globalFormManagementServices.updateGlobalFormLibraryField(userData);
        if (data?.statusCode === 200) {
          getGlobalFormFieldGroupLibrary();
          findGlobalFormFieldGroupLibrary()
          setOpenOption(false)
          setToggle1()
        }
      }
      setButtonLoader(false);
    });
  };

  const days = Array.from({ length: 31 }, (_, index) => {
    const day = index + 1;
    return day.toString().padStart(2, '0');
  });

  const hours12 = Array.from({ length: 12 }, (_, index) => {
    const hour = index + 1;
    return hour.toString().padStart(2, '0');
  });

  const hours24 = Array.from({ length: 24 }, (_, index) => {
    const hour = index + 1;
    return hour.toString().padStart(2, '0');
  });

  const minuteSecond = Array.from({ length: 60 }, (_, index) => {
    const minuteSecondData = index + 1;
    return minuteSecondData.toString().padStart(2, '0');
  });

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 150 }, (_, index) => currentYear - index);

  const textMonths = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  const numberMonths = Array.from({ length: 12 }, (_, index) => {
    const numberMonth = index + 1;
    return numberMonth.toString().padStart(2, '0');
  });

  function isMMMFormat(dateStr) {
    let regexMMM = /\b(MMM)\b/i;
    const parts = dateStr.split('_');
    if (dateStr === "DD_MMM_YYYY" || dateStr === "YYYY_MMM_DD") {
      return /^[A-Za-z]{3}$/.test(parts[1]);
    } else if (regexMMM.test(dateStr)) {
      return true;
    } else {
      return false;
    }
  }

  const chunkOptionArray = (arr = [], chunks) => {
    const result = [];
    const size = Math.ceil(arr.length / chunks);
    for (let i = 0; i < chunks; i++) {
      result.push(arr.slice(i * size, (i + 1) * size));
    }
    return result;
  };

  const getDynamicColor = (index, total, baseColor) => {
    const minLightness = 30;
    const maxLightness = 60;

    const percent = total <= 1 ? 0 : index / (total - 1);
    const lightness = maxLightness - percent * (maxLightness - minLightness);

    if (baseColor === "red") {
      return `hsl(0, 70%, ${lightness}%)`;
    } else {
      return `hsl(120, 50%, ${lightness}%)`;
    }
  };

  function isFirstPartYYYY(dateStr) {
    return dateStr.startsWith("YYYY");
  }

  useEffect(() => {
    getGlobalFormFieldGroupLibrary();
  }, []);

  useEffect(() => {
    if (categoryId) {
      findGlobalFormFieldGroupLibrary();
    }
  }, [categoryId]);

  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    const reordered = Array.from(formFields);
    const [movedItem] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, movedItem);
    setFormFields(reordered);
  };

  const nameCount = {};
  const duplicatesFieldName = [];
  for (const item of formFields) {
    nameCount[item.fieldName] = (nameCount[item.fieldName] || 0) + 1;
  }
  for (const item of formFields) {
    if (nameCount[item.fieldName] > 1) {
      duplicatesFieldName.push(item.id);
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenOption(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <SplitPane split="vertical" minSize={"20%"} className="position-relative" style={{ height: "calc(100vh - 146px)" }}>
        <div>
          <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
            <Form.Label className="m-0 fw-bold">Form Library</Form.Label>
            <button
              onClick={setToggle2}
              className={`updateProfile`}
            >
              Add Library
            </button>
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 182px)" }}>
            {loading ? (
              <PageLoader/>
            ) : formFieldLibraryList?.length === 0 ? (
              <NoDataFoundTable MSG={"Form field library not found!"} />
            ) : (
              <div className="p-2">
                <ListGroup>
                  {formFieldLibraryList.map((fieldLibrary, index) => {
                    const isActive = fieldLibrary?.categoryId === categoryId;
                    const isMenuOpen = openOption === index;
                    return (
                      <>
                        <ListGroup.Item action 
                          title={fieldLibrary?.categoryName}
                          onClick={() => setCategoryId(fieldLibrary?.categoryId)}
                          key={fieldLibrary?.categoryId || index}
                          className={`hstack justify-content-between p-0 ${categoryId === fieldLibrary?.categoryId && "selectedMenu"}`}
                        >
                          <div style={{padding: "5px 10px 7px 10px"}} ref={AppsRef}>
                            <span>{fieldLibrary?.categoryName}</span>
                          </div>
                          <div className="position-relative" style={{padding: "5px 10px 7px 10px"}}>
                            <div
                              onClick={() => setOpenOption(isMenuOpen ? null : index)}
                              className={`${isActive ? "btn-active text-white" : "btn-outline-secondary"}`}
                            >
                              <CiMenuKebab />
                            </div>
                            <Collapse in={isMenuOpen === true}>
                              <div className="position-absolute end-0 z-1" style={{ top: 36 }}>
                                <ListGroup className="br3" style={{ fontSize: 12 }}>
                                  <ListGroup.Item onClick={() => { setCategoryId(fieldLibrary?.categoryId); setCategoryName(fieldLibrary?.categoryName); setToggle1() }} action className="text-nowrap py-1 px-3 text-primary"><FaEdit className="mb-1 me-1" /> Edit</ListGroup.Item>
                                  <ListGroup.Item disabled onClick={() => deleteGlobalFormFieldLibrary(fieldLibrary?._id)} action className="text-nowrap py-1 px-3 text-danger"><FaTrash className="mb-1 me-1" /> Delete</ListGroup.Item>
                                </ListGroup>
                              </div>
                            </Collapse>
                          </div>
                        </ListGroup.Item>
                      </>
                    );
                  })}
                </ListGroup>
              </div>
            )}
          </div>
        </div>    
        <Container fluid>
          <Row>
            <Form.Group as={Col} className="p-0" md={categoryId ? 11 : 12}>
              <div className="hstack flex-column justify-content-between w-100" style={{height: "calc(100vh - 147px)"}}>
                {!categoryId ?
                  <div className="hstack justify-content-center h-100 fw-bold text-muted">
                    First Click Any Library!
                  </div>
                  : fieldLoading ?
                    <div
                      className="hstack justify-content-center"
                      style={{ height: "calc(100vh - 182px)" }}
                    >
                      <PageLoader/>
                    </div>
                    : formFields.length === 0 ?
                      <div className="hstack justify-content-center h-100 fw-bold text-muted">
                        Add Field!
                      </div>
                      :
                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="form-formFields-droppable">
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              className="overflow-auto w-100 bg-light pb-3 bg-blue-subtle"
                              style={{ height: "calc(100vh - 100px)" }}
                            >
                              <Container fluid>
                                <Row>
                                  {formFields.map((field, index) => (
                                    <Draggable
                                      key={field?.id}
                                      draggableId={String(field?.id)}
                                      index={index}
                                    >
                                      {(provided) => (
                                        <Form.Group
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          as={Col}
                                          md={Number(field?.columnSize)}
                                        >
                                          <div className={
                                            field?.type === "heading"
                                              ? "pe-3 py-2 mt-3"
                                              : `bg-white border rounded p-3 mt-3 position-relative ${duplicatesFieldName?.includes(field?.id) && "border-danger"}`
                                          }>
                                            {field?.type !== "heading" &&
                                              <div className="position-absolute" style={{ top: -13 }}>
                                                <Badge bg={`${(field?.conditionalFields || [])?.length > 0 ? "danger" : "primary"}`} className="br3 px-3 text-capitalize">{field?.type}</Badge>
                                                {field?.customField === "yes" ?
                                                  <Badge bg="primary" className="br3 px-3 text-capitalize mx-2">Custom</Badge>
                                                  : field?.groupField === "yes" &&
                                                  <Badge bg="primary" className="br3 px-3 text-capitalize mx-2">Group</Badge>
                                                }
                                              </div>
                                            }
                                            <div className="d-flex justify-content-end align-items-center">
                                              <div className="z-1 d-flex gap-3">
                                                <FaRegEdit
                                                  title="Edit"
                                                  className="CP"
                                                  style={{ pointerEvents: "auto" }}
                                                  onClick={(e) => {
                                                    setFieldId(field?.id);
                                                    setToggle();
                                                    setActiveTab("general");
                                                    e.stopPropagation();
                                                  }}
                                                />
                                                <IoDuplicateOutline
                                                  className="CP"
                                                  title="Duplicate"
                                                  style={{ pointerEvents: "auto" }}
                                                  onClick={(e) => { handleDuplicateFormField(field?.id); e.stopPropagation(); }}
                                                />
                                                <RiDeleteBin6Line
                                                  className="text-danger CP"
                                                  title="Delete"
                                                  style={{ pointerEvents: "auto" }}
                                                  onClick={(e) => { handleFormFieldDelete(index); e.stopPropagation(); }}
                                                />
                                              </div>
                                            </div>
                                            {field?.type === "heading" ? (
                                              <div className="d-flex justify-content-between align-items-center">
                                                <h5 className={`d-flex gap-2 mb-0`}>
                                                  <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                    {field?.fieldLabelType ?
                                                      <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                      :
                                                    <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                    }
                                                  </span>
                                                </h5>
                                              </div>
                                            ) : field?.customField === "yes" ? (
                                              <>
                                                {(field?.type === "text" || field?.type === "number") ?
                                                  <div className="hstack gap-2 w-100">
                                                    <div className="w-100">
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`d-flex gap-2 mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.fieldLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          {field?.fieldHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.fieldHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        type={field?.type}
                                                        placeholder={field?.fieldPlaceholder || ""}
                                                        style={{ width: field?.fieldSize }}
                                                      />
                                                    </div>
                                                    {field?.fieldUnit === "yes" &&
                                                      <div className="w-100">
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          {field?.fieldUnit === "yes" &&
                                                            <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                              <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.fieldUnitLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                              {field?.fieldUnitHelp &&
                                                                <span>
                                                                  <BsFillQuestionCircleFill
                                                                    title={field?.fieldUnitHelp}
                                                                    style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                  />
                                                                </span>
                                                              }
                                                            </h5>
                                                          }
                                                        </div>
                                                        <Form.Select
                                                          className="br3"
                                                          required
                                                          style={{ fontSize: 12 }}
                                                          disabled={(field?.unitOptions || []).length === 0}
                                                        >
                                                          <option>Select Unit Option</option>
                                                          {(field?.unitOptions || [])?.map((option, i) => (
                                                            <option key={i} value={option?.option}>
                                                              {option?.option}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </div>
                                                    }
                                                  </div>
                                                  : field?.type === "dropdown" ? (
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`d-flex gap-2 mb-0`}>
                                                          <div className="d-flex gap-2">
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                              {field?.fieldLabelType ?
                                                                <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                :
                                                              <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                              }
                                                            </span>
                                                            {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          </div>
                                                          {field?.fieldHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.fieldHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      </div>
                                                      <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                        <Form.Select
                                                          className="br3"
                                                          style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                          disabled={(field?.options || []).length === 0}
                                                        >
                                                          <option>Select Option</option>
                                                          {(field?.options || [])?.map((option, i) => (
                                                            <option key={i} value={option?.option}>
                                                              {option?.option}
                                                            </option>
                                                          ))}
                                                        </Form.Select>
                                                      </div>
                                                    </>
                                                  ) : field?.type === "radio" ? (
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`d-flex gap-2 mb-0`}>
                                                          <div className="d-flex gap-2">
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                              {field?.fieldLabelType ?
                                                                <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                :
                                                              <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                              }
                                                            </span>
                                                            {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          </div>
                                                          {field?.fieldHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.fieldHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      </div>
                                                      <Row>
                                                        {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                          <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                            {chunk?.map((option, i) => (
                                                              <Form.Check
                                                                key={i}
                                                                type={field?.type}
                                                                label={option.option}
                                                                name={`radioGroup_${field?.id}`}
                                                                style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                              />
                                                            ))}
                                                          </Form.Group>
                                                        ))}
                                                      </Row>
                                                    </>
                                                  ) : field?.type === "checkbox" ? (
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`d-flex gap-2 mb-0`}>
                                                          <div className="d-flex gap-2">
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                              {field?.fieldLabelType ?
                                                                <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                :
                                                              <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                              }
                                                            </span>
                                                            {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          </div>
                                                          {field?.fieldHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.fieldHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      </div>
                                                      <Row>
                                                        {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                          <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                            {chunk?.map((option, i) => (
                                                              <Form.Check
                                                                key={i}
                                                                type={field?.type}
                                                                label={option.option}
                                                                name={field?.label}
                                                                style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                              />
                                                            ))}
                                                          </Form.Group>
                                                        ))}
                                                      </Row>
                                                    </>
                                                  ) : field?.type === "date" ? (
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`d-flex gap-2 mb-0`}>
                                                          <div className="d-flex gap-2">
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                              {field?.fieldLabelType ?
                                                                <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                :
                                                              <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                              }
                                                            </span>
                                                            {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          </div>
                                                          {field?.fieldHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.fieldHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      </div>
                                                      <div className="w-100 hstack gap-2">
                                                        {isFirstPartYYYY(field?.dateFormat) ?
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.yearLabel}
                                                            </h5>
                                                            <Form.Select
                                                              className="br3"
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Year</option>
                                                              <option>UNK</option>
                                                              {years?.map((year, i) => (
                                                                <option key={i} value={year}>
                                                                  {year}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                          :
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.dayLabel}
                                                            </h5>
                                                            <Form.Select
                                                              className="br3"
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Day</option>
                                                              <option>UNK</option>
                                                              {days?.map((day, i) => (
                                                                <option key={i} value={day}>
                                                                  {day}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                        }
                                                        <div className="w-100">
                                                          <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                            {field?.monthLabel}
                                                          </h5>
                                                          <Form.Select
                                                            className="br3"
                                                            required
                                                            style={{ fontSize: 12 }}
                                                          >
                                                            <option>Select Month</option>
                                                            <option>UNK</option>
                                                            {(isMMMFormat(field?.dateFormat) ? textMonths : numberMonths)?.map((month, i) => (
                                                              <option key={i} value={month}>
                                                                {month}
                                                              </option>
                                                            ))}
                                                          </Form.Select>
                                                        </div>
                                                        {isFirstPartYYYY(field?.dateFormat) ?
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.dayLabel}
                                                            </h5>
                                                            <Form.Select
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Day</option>
                                                              <option>UNK</option>
                                                              {days?.map((day, i) => (
                                                                <option key={i} value={day}>
                                                                  {day}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                          :
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.yearLabel}
                                                            </h5>
                                                            <Form.Select
                                                              className="br3"
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Year</option>
                                                              <option>UNK</option>
                                                              {years?.map((year, i) => (
                                                                <option key={i} value={year}>
                                                                  {year}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                        }
                                                      </div>
                                                      {field?.dateFormat &&
                                                        <Form.Text style={{ fontSize: 10, fontWeight: 600 }}>
                                                          <b>Date Format:</b>{" "}
                                                          {(field?.dateFormat === "DD_MMM_YYYY" || field?.dateFormat === "YYYY_MMM_DD" || field?.dateFormat === "DD_MM_YYYY" || field?.dateFormat === "YYYY_MM_DD") ? (field?.dateFormat)?.replace(/_/g, "") : field?.dateFormat}
                                                        </Form.Text>
                                                      }
                                                    </>
                                                  ) : field?.type === "time" && (
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`d-flex gap-2 mb-0`}>
                                                          <div className="d-flex gap-2">
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                              {field?.fieldLabelType ? <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                                :
                                                              <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                              }
                                                            </span>
                                                            {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          </div>
                                                          {field?.fieldHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.fieldHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      </div>
                                                      <div className="w-100 hstack gap-2">
                                                        <div className="w-100">
                                                          <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                            {field?.hourLabel}
                                                          </h5>
                                                          <Form.Select
                                                            className="br3"
                                                            required
                                                            style={{ fontSize: 12 }}
                                                          >
                                                            <option>Select Hour</option>
                                                            <option>UNK</option>
                                                            {(field?.clockTimeFormat === "24" ? hours24 : hours12)?.map((hour, i) => (
                                                              <option key={i} value={hour}>
                                                                {hour}
                                                              </option>
                                                            ))}
                                                          </Form.Select>
                                                        </div>
                                                        <div className="w-100">
                                                          <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                            {field?.minuteLabel}
                                                          </h5>
                                                          <Form.Select
                                                            className="br3"
                                                            required
                                                            style={{ fontSize: 12 }}
                                                          >
                                                            <option>Select Minute</option>
                                                            <option>UNK</option>
                                                            {minuteSecond?.map((minute, i) => (
                                                              <option key={i} value={minute}>
                                                                {minute}
                                                              </option>
                                                            ))}
                                                          </Form.Select>
                                                        </div>
                                                        {field?.timeFormat === "hhmmss" &&
                                                          <div className="w-100">
                                                            <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                              {field?.secondLabel}
                                                            </h5>
                                                            <Form.Select
                                                              className="br3"
                                                              required
                                                              style={{ fontSize: 12 }}
                                                            >
                                                              <option>Select Second</option>
                                                              <option>UNK</option>
                                                              {minuteSecond?.map((second, i) => (
                                                                <option key={i} value={second}>
                                                                  {second}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                        }
                                                      </div>
                                                    </>
                                                  )}
                                                {(field?.referenceRangeLimit === "yes" || field?.referenceRangeIndicator === "yes" || (!field?.referenceRangeIndicatorOptions?.every(item => item.disable === "yes") && field?.clinicalSignificance === "yes")) &&
                                                  <div className="d-flex gap-2 w-100 mt-3">
                                                    {field?.referenceRangeLowerLimit === "yes" &&
                                                      <div className="w-100">
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.referenceRangeLowerLimitLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            {field?.referenceRangeLowerLimitHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.referenceRangeLowerLimitHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        {(field?.referenceRangeLowerLimitType === "text" || field?.referenceRangeLowerLimitType === "number") ?
                                                          <Form.Control
                                                            type={field?.referenceRangeLowerLimitType}
                                                            placeholder={field?.referenceRangeLowerLimitPlaceholder || ""}
                                                          />
                                                          : field?.referenceRangeLowerLimitType === "dropdown" ?
                                                            <Form.Select
                                                              style={{ fontSize: 12 }}
                                                              className="br3"
                                                              disabled={(field?.referenceRangeLowerLimitOptions || []).length === 0}
                                                            >
                                                              <option>Select Option</option>
                                                              {(field?.referenceRangeLowerLimitOptions || [])?.map((option, i) => (
                                                                <option key={i} id={option?.id} value={option?.option}>
                                                                  {option?.option}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                            : field?.referenceRangeLowerLimitType === "radio" &&
                                                            (field?.referenceRangeLowerLimitOptions || [])?.map((option, i) => (
                                                              <Form.Check
                                                                key={i}
                                                                type="radio"
                                                                label={option?.option}
                                                                name={`referenceRangeLowerLimit_${field.id}`}
                                                              />
                                                            ))
                                                        }
                                                      </div>
                                                    }
                                                    {field?.referenceRangeUpperLimit === "yes" &&
                                                      <div className="w-100">
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.referenceRangeUpperLimitLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            {field?.referenceRangeUpperLimitHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.referenceRangeUpperLimitHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        {(field?.referenceRangeUpperLimitType === "text" || field?.referenceRangeUpperLimitType === "number") ?
                                                          <Form.Control
                                                            type={field?.referenceRangeUpperLimitType}
                                                            placeholder={field?.referenceRangeUpperLimitPlaceholder || ""}
                                                          />
                                                          : field?.referenceRangeUpperLimitType === "dropdown" ?
                                                            <Form.Select
                                                              style={{ fontSize: 12 }}
                                                              className="br3"
                                                              disabled={(field?.referenceRangeUpperLimitOptions || []).length === 0}
                                                            >
                                                              <option>Select Option</option>
                                                              {(field?.referenceRangeUpperLimitOptions || [])?.map((option, i) => (
                                                                <option key={i} id={option?.id} value={option?.option}>
                                                                  {option?.option}
                                                                </option>
                                                              ))}
                                                            </Form.Select>
                                                            : field?.referenceRangeUpperLimitType === "radio" &&
                                                            (field?.referenceRangeUpperLimitOptions || [])?.map((option, i) => (
                                                              <Form.Check
                                                                key={i}
                                                                type="radio"
                                                                label={option?.option}
                                                                name={`referenceRangeUpperLimit_${field.id}`}
                                                              />
                                                            ))
                                                        }
                                                      </div>
                                                    }
                                                    {field?.referenceRangeIndicator === "yes" &&
                                                      <div className="w-100">
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.referenceRangeIndicatorLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            {field?.referenceRangeIndicatorHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.referenceRangeIndicatorHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        {field?.referenceRangeIndicatorOptions?.map((option, i) => (
                                                          <Form.Check
                                                            key={i}
                                                            type="radio"
                                                            label={option?.option}
                                                            name={`referenceRangeIndicator_${field?.id}`}
                                                          />
                                                        ))}
                                                      </div>
                                                    }
                                                    {(!field?.referenceRangeIndicatorOptions?.every(item => item.disable === "yes") && field?.clinicalSignificance === "yes") &&
                                                      <div className="w-100">
                                                        <div className="d-flex justify-content-between align-items-center my-2">
                                                          <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                            <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.clinicalSignificanceLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                            {field?.clinicalSignificanceHelp &&
                                                              <span>
                                                                <BsFillQuestionCircleFill
                                                                  title={field?.clinicalSignificanceHelp}
                                                                  style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                                />
                                                              </span>
                                                            }
                                                          </h5>
                                                        </div>
                                                        <Form.Check
                                                          type="radio"
                                                          label="CS"
                                                          name={`clinicalSignificance_${field?.id}`}
                                                        />
                                                        <Form.Check
                                                          type="radio"
                                                          label="NCS"
                                                          name={`clinicalSignificance_${field?.id}`}
                                                        />
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                                {field?.customRemark === "yes" &&
                                                  <div className="w-100">
                                                    <div style={{ marginTop: 7 }} className="d-flex justify-content-between align-items-center mb-2">
                                                      <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.customRemarkLabel}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                        {field?.customRemarkHelp &&
                                                          <span>
                                                            <BsFillQuestionCircleFill
                                                              title={field?.customRemarkHelp}
                                                              style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                            />
                                                          </span>
                                                        }
                                                      </h5>
                                                    </div>
                                                    <Form.Control
                                                      as="textarea"
                                                      placeholder={field?.customRemarkPlaceholder || ""}
                                                    />
                                                  </div>
                                                }
                                              </>
                                            ) : field?.type === "dropdown" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                  <Form.Select
                                                    className="br3"
                                                    style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                    disabled={(field?.options || []).length === 0}
                                                  >
                                                    <option>Select Option</option>
                                                    {(field?.options || [])?.map((option, i) => (
                                                      <option key={i} value={option?.option}>
                                                        {option?.option}
                                                      </option>
                                                    ))}
                                                  </Form.Select>
                                                  {field?.customFieldRemark === "yes" &&
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                            {field?.customFieldRemarkLabel}
                                                          </span>
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                        as="textarea"
                                                        placeholder={"Enter Remark"}
                                                      />
                                                    </>
                                                  }
                                                </div>
                                              </>
                                            ) : field?.type === "radio" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <Row>
                                                  {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                    <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                      {chunk?.map((option, i) => (
                                                        <Form.Check
                                                          key={i}
                                                          type={field?.type}
                                                          label={option.option}
                                                          name={`radioGroup_${field?.id}`}
                                                          style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                        />
                                                      ))}
                                                    </Form.Group>
                                                  ))}
                                                </Row>
                                                {field?.customFieldRemark === "yes" &&
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                      <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                          {field?.customFieldRemarkLabel}
                                                        </span>
                                                      </h5>
                                                    </div>
                                                    <Form.Control
                                                      style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                      as="textarea"
                                                      placeholder={"Enter Remark"}
                                                    />
                                                  </div>
                                                }
                                              </>
                                            ) : field?.type === "checkbox" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <Row>
                                                  {chunkOptionArray(field?.options, (field?.optionShowColumn || 1))?.map((chunk, colIdx) => (
                                                    <Form.Group key={colIdx} as={Col} md={12 / (field?.optionShowColumn || 1)} className={field?.radioVisible === "horizontal" && 'hstack gap-2'}>
                                                      {chunk?.map((option, i) => (
                                                        <Form.Check
                                                          key={i}
                                                          type={field?.type}
                                                          label={option.option}
                                                          name={field?.label}
                                                          style={{ width: field?.radioVisible === "horizontal" ? "auto" : `${Number(field?.fieldWidthSize || 100)}%` }}
                                                        />
                                                      ))}
                                                    </Form.Group>
                                                  ))}
                                                </Row>
                                                {field?.customFieldRemark === "yes" &&
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                      <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                          {field?.customFieldRemarkLabel}
                                                        </span>
                                                      </h5>
                                                    </div>
                                                    <Form.Control
                                                      style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                      as="textarea"
                                                      placeholder={"Enter Remark"}
                                                    />
                                                  </div>
                                                }
                                              </>
                                            ) : field?.type === "textarea" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                  <Form.Control
                                                    as="textarea"
                                                    rows={4}
                                                    placeholder={field?.fieldPlaceholder || ""}
                                                    style={{ width: `${Number(field?.inputWidthSize || 100)}%` }}
                                                  />
                                                </div>
                                              </>
                                            ) : field?.type === "range" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center">
                                                  <h5 className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} mb-2`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                  <RangeScale
                                                    startLinePoint={Number(field?.startRange)}
                                                    endLinePoint={Number(field?.endRange)}
                                                    inputWidthSize={`${Number(field?.inputWidthSize || 100)}%`}
                                                    dataEntryType
                                                    rangeValue={0}
                                                  />
                                                  {field?.customFieldRemark === "yes" &&
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                            {field?.customFieldRemarkLabel}
                                                          </span>
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                        as="textarea"
                                                        placeholder={"Enter Remark"}
                                                      />
                                                    </>
                                                  }
                                                </div>
                                              </>
                                            ) : field?.type === "scale" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} className="hstack">
                                                  {(field?.options || []).map((option, i) => {
                                                    const isFilled = selectScaleIndex !== null && i <= selectScaleIndex;
                                                    const total = selectScaleIndex !== null ? selectScaleIndex + 1 : (field?.options || []).length;
                                                    const backgroundColor = isFilled
                                                      ? getDynamicColor(i, total, "green")
                                                      : "transparent";
                                                    const borderColor = isFilled
                                                      ? getDynamicColor(i, total, "green")
                                                      : "#dee2e6";
                                                    return (
                                                      <div
                                                        key={i}
                                                        onClick={() => setSelectScaleIndex(i)}
                                                        className="p-1 px-2"
                                                        style={{
                                                          fontSize: 12,
                                                          cursor: "pointer",
                                                          background: backgroundColor,
                                                          border: `1px solid ${borderColor}`,
                                                          color: isFilled ? "#fff" : "#000",
                                                          transition: "all 0.3s ease",
                                                        }}
                                                      >
                                                        {option?.option}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                                {field?.customFieldRemark === "yes" &&
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                      <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                          {field?.customFieldRemarkLabel}
                                                        </span>
                                                      </h5>
                                                    </div>
                                                    <Form.Control
                                                      style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                      as="textarea"
                                                      placeholder={"Enter Remark"}
                                                    />
                                                  </div>
                                                }
                                              </>
                                            ) : field?.type === "file" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                  <Form.Control
                                                    accept={field?.fieldFileType
                                                      ?.map((item) => item.value)
                                                      ?.join(", ")}
                                                    type={field?.type}
                                                    style={{ width: `${Number(field?.inputWidthSize || 100)}%` }}
                                                    placeholder={field?.fieldPlaceholder || ""}
                                                    disabled={(field?.fieldFileType || [])?.length === 0}
                                                  />
                                                  {(field?.fieldFileType || [])?.length > 0 &&
                                                    <Form.Text style={{ fontSize: 10, fontWeight: 600 }}>
                                                      <b>Supported File:</b>{" "}
                                                      {field?.fieldFileType
                                                        ?.map((item) => item.label)
                                                        ?.join(", ")}
                                                    </Form.Text>
                                                  }
                                                  {field?.customFieldRemark === "yes" &&
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                            {field?.customFieldRemarkLabel}
                                                          </span>
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                        as="textarea"
                                                        placeholder={"Enter Remark"}
                                                      />
                                                    </>
                                                  }
                                                </div>
                                              </>
                                            ) : (field?.type === "text" || field?.type === "number") ? (
                                              <div className="hstack gap-2 w-100">
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                  <div className="d-flex justify-content-between align-items-center my-2">
                                                    <h5 className={`d-flex gap-2 mb-0`}>
                                                      <div className="d-flex gap-2">
                                                        <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                          {field?.fieldLabelType ?
                                                            <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                            :
                                                          <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                          }
                                                        </span>
                                                        {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                      </div>
                                                      {field?.fieldHelp &&
                                                        <span>
                                                          <BsFillQuestionCircleFill
                                                            title={field?.fieldHelp}
                                                            style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                          />
                                                        </span>
                                                      }
                                                    </h5>
                                                  </div>
                                                  <Form.Control
                                                    type={field?.type}
                                                    placeholder={field?.fieldPlaceholder || ""}
                                                    style={{ width: `${Number(field?.inputWidthSize || 100)}%` }}
                                                  />
                                                </div>
                                                {field?.fieldUnit === "yes" &&
                                                  <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                      {field?.fieldUnit === "yes" &&
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >{field?.fieldUnitLabel} {field?.fieldUnitName && `| ${field?.fieldUnitName}`}</span> {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                          {field?.fieldUnitHelp &&
                                                            <span>
                                                              <BsFillQuestionCircleFill
                                                                title={field?.fieldUnitHelp}
                                                                style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                              />
                                                            </span>
                                                          }
                                                        </h5>
                                                      }
                                                    </div>
                                                    <Form.Select
                                                      className="br3"
                                                      required
                                                      style={{ fontSize: 12 }}
                                                      disabled={(field?.unitOptions || []).length === 0}
                                                    >
                                                      <option>Select Unit Option</option>
                                                      {(field?.unitOptions || [])?.map((option, i) => (
                                                        <option key={i} value={option?.option}>
                                                          {option?.option}
                                                        </option>
                                                      ))}
                                                    </Form.Select>
                                                  </div>
                                                }
                                              </div>
                                            ) : field?.type === "date" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} className="hstack gap-2">
                                                  {isFirstPartYYYY(field?.dateFormat) ?
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.yearLabel}
                                                      </h5>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Year</option>
                                                        <option>UNK</option>
                                                        {years?.map((year, i) => (
                                                          <option key={i} value={year}>
                                                            {year}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                    :
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.dayLabel}
                                                      </h5>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Day</option>
                                                        <option>UNK</option>
                                                        {days?.map((day, i) => (
                                                          <option key={i} value={day}>
                                                            {day}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                  }
                                                  <div className="w-100">
                                                    <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                      {field?.monthLabel}
                                                    </h5>
                                                    <Form.Select
                                                      className="br3"
                                                      required
                                                      style={{ fontSize: 12 }}
                                                    >
                                                      <option>Select Month</option>
                                                      <option>UNK</option>
                                                      {(isMMMFormat(field?.dateFormat) ? textMonths : numberMonths)?.map((month, i) => (
                                                        <option key={i} value={month}>
                                                          {month}
                                                        </option>
                                                      ))}
                                                    </Form.Select>
                                                  </div>
                                                  {isFirstPartYYYY(field?.dateFormat) ?
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.dayLabel}
                                                      </h5>
                                                      <Form.Select
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Day</option>
                                                        <option>UNK</option>
                                                        {days?.map((day, i) => (
                                                          <option key={i} value={day}>
                                                            {day}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                    :
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.yearLabel}
                                                      </h5>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Year</option>
                                                        <option>UNK</option>
                                                        {years?.map((year, i) => (
                                                          <option key={i} value={year}>
                                                            {year}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                  }
                                                </div>
                                                {field?.dateFormat &&
                                                  <Form.Text style={{ fontSize: 10, fontWeight: 600 }}>
                                                    <b>Date Format:</b>{" "}
                                                    {(field?.dateFormat === "DD_MMM_YYYY" || field?.dateFormat === "YYYY_MMM_DD" || field?.dateFormat === "DD_MM_YYYY" || field?.dateFormat === "YYYY_MM_DD") ? (field?.dateFormat)?.replace(/_/g, "") : field?.dateFormat}
                                                  </Form.Text>
                                                }
                                              </>
                                            ) : field?.type === "time" ? (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} className="hstack gap-2">
                                                  <div className="w-100">
                                                    <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                      {field?.hourLabel}
                                                    </h5>
                                                    <Form.Select
                                                      className="br3"
                                                      required
                                                      style={{ fontSize: 12 }}
                                                    >
                                                      <option>Select Hour</option>
                                                      <option>UNK</option>
                                                      {(field?.clockTimeFormat === "24" ? hours24 : hours12)?.map((hour, i) => (
                                                        <option key={i} value={hour}>
                                                          {hour}
                                                        </option>
                                                      ))}
                                                    </Form.Select>
                                                  </div>
                                                  <div className="w-100">
                                                    <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                      {field?.minuteLabel}
                                                    </h5>
                                                    <Form.Select
                                                      className="br3"
                                                      required
                                                      style={{ fontSize: 12 }}
                                                    >
                                                      <option>Select Minute</option>
                                                      <option>UNK</option>
                                                      {minuteSecond?.map((minute, i) => (
                                                        <option key={i} value={minute}>
                                                          {minute}
                                                        </option>
                                                      ))}
                                                    </Form.Select>
                                                  </div>
                                                  {field?.timeFormat === "hhmmss" &&
                                                    <div className="w-100">
                                                      <h5 style={{ fontSize: 14 }} className="fw-bold mb-2">
                                                        {field?.secondLabel}
                                                      </h5>
                                                      <Form.Select
                                                        className="br3"
                                                        required
                                                        style={{ fontSize: 12 }}
                                                      >
                                                        <option>Select Second</option>
                                                        <option>UNK</option>
                                                        {minuteSecond?.map((second, i) => (
                                                          <option key={i} value={second}>
                                                            {second}
                                                          </option>
                                                        ))}
                                                      </Form.Select>
                                                    </div>
                                                  }
                                                </div>
                                              </>
                                            ) : field?.type === "score" && (
                                              <>
                                                <div className="d-flex justify-content-between align-items-center my-2">
                                                  <h5 className={`d-flex gap-2 mb-0`}>
                                                    <div className="d-flex gap-2">
                                                      <span style={{ marginTop: field?.fieldLabelType ? -5 : -2}} >
                                                        {field?.fieldLabelType ?
                                                          <div className="fs-14" style={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: field?.fieldLabel }} />
                                                          :
                                                        <span style={{ fontSize: Number(field?.labelSize), color: field?.labelColor }} className={`d-flex gap-2 ${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"}`}>{field?.fieldLabel}</span>
                                                        }
                                                      </span>
                                                      {field?.fieldMandatory === "yes" && <span className="text-danger">*</span>}
                                                    </div>
                                                    {field?.fieldHelp &&
                                                      <span>
                                                        <BsFillQuestionCircleFill
                                                          title={field?.fieldHelp}
                                                          style={{ marginTop: -4, marginLeft: 5, fontSize: 14 }}
                                                        />
                                                      </span>
                                                    }
                                                  </h5>
                                                </div>
                                                <div style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }}>
                                                  <ScorePercentageGraph
                                                    scoreType={field?.scoreType}
                                                    startScore={field?.startScore}
                                                    endScore={field?.endScore}
                                                    boxColumn={field?.boxColumn}
                                                    dataEntryType
                                                  />
                                                  {field?.customFieldRemark === "yes" &&
                                                    <>
                                                      <div className="d-flex justify-content-between align-items-center my-2">
                                                        <h5 className={`${field?.labelBold && "fw-bold"} ${field?.labelItalic && "fst-italic"} ${field?.labelUnderline && "text-decoration-underline"} d-flex gap-2 mb-0`}>
                                                          <span style={{ marginTop: field?.fieldLabelType ? -5 : -2, fontSize: Number(field?.labelSize), color: field?.labelColor }} >
                                                            {field?.customFieldRemarkLabel}
                                                          </span>
                                                        </h5>
                                                      </div>
                                                      <Form.Control
                                                        style={{ width: `${Number(field?.inputWidthSize || 100)}%`, fontSize: 12 }}
                                                        as="textarea"
                                                        placeholder={"Enter Remark"}
                                                      />
                                                    </>
                                                  }
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </Form.Group>
                                      )}
                                    </Draggable>
                                  ))}
                                  {provided.placeholder}
                                </Row>
                              </Container>
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                }
                {categoryId &&
                  <div className="w-100 p-2 pe-3 border-top bg-light text-end">
                    <button
                      disabled={duplicatesFieldName?.length > 0}
                      onClick={addUpdateGlobalFormFieldLibrary}
                      className="updateProfile"
                      style={{ fontSize: 12 }}
                    >
                      Save Fields
                    </button>
                  </div>
                }
              </div>
            </Form.Group>
            {categoryId &&
              <Form.Group as={Col} md={1} className="border-start overflow-auto p-0" style={{height: "calc(100vh - 147px)"}}>
                <div className="hstack gap-2 flex-wrap p-2">
                  {[
                    "heading",
                    "text",
                    "number",
                    "textarea",
                    "date",
                    "time",
                    "dropdown",
                    "radio",
                    "checkbox",
                    "scale",
                    "score",
                    "range",
                    "file",
                  ].map((field) => (
                    <button
                      key={field}
                      style={{ fontSize: 10 }}
                      title={`Add ${field}`}
                      className="py-1 px-2 CP border btn-outline-secondary btn w-100"
                      onClick={() => handleAddFormField(field)}
                    >
                      {field.charAt(0).toUpperCase() + field.slice(1)}
                    </button>
                  ))}
                </div>
              </Form.Group>
            }
          </Row>
        </Container>
      </SplitPane>
      <FormCustomization
        Show={!toggle}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        Hide={setToggle}
        handleUpdateFormField={handleUpdateFormField}
        fieldId={fieldId}
        categoryId={categoryId}
        formFields={formFields?.filter(item => item.id !== fieldId)}
        setFormFields={setFormFields}
        conditionaLogicTab={conditionaLogicTab}
        setConditionaLogicTab={setConditionaLogicTab}
        formCategory={"all"}
        formType={"regular"}
        domainCode={""}
        domainLabel={""}
        formFieldLibraryList={formFieldLibraryList?.filter(item => (item.category === "all"))}
        fieldData={formFields?.find(item => item.id === fieldId)}
      />
      <UpdateFormFieldLibrary
        Show={!toggle1}
        Hide={setToggle1}
        setCategoryName={setCategoryName}
        categoryName={categoryName}
        buttonLoader={buttonLoader}
        updateGlobalFormLibraryField={updateGlobalFormLibraryField}
      />
      <AddFormFieldLibraryForm
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Add New Form Field Library"}
        getGlobalFormFieldGroupLibrary={getGlobalFormFieldGroupLibrary}
      />
    </>
  );
};

export default FormFieldLibraryEditor;
